"use client";

import type { Locale } from "@/i18n/i18n-config";
import { ErrorScreen } from "@/screens/Error";
import type { Metadata } from "next";
import { getTranslations } from "next-intl/server";

type Props = {
  params: Promise<{ locale: Locale }>;
};

export async function generateMetadata({ params }: Props): Promise<Metadata> {
  const locale = (await params).locale;
  const t = await getTranslations({ locale, namespace: "errors.error" });

  return {
    title: t("metadata.title"),
    description: t("metadata.description"),
  };
}

export default ErrorScreen;
